import { Instance } from 'mobx-state-tree';
import { DayOfWeekStore } from '../../../store/DayOfWeekStore';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';
import { DayOfWeek } from '../../../store/models/DayOfWeek';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';

interface DayOfWeekFormFieldProps extends WithTranslateProps {
  DayOfWeekStore?: Instance<typeof DayOfWeekStore>;
}

const DayOfWeekSelectInputFormField = SelectInputFormField.ofType<any, string>();

@inject('DayOfWeekStore')
@observer
class DayOfWeekFormField extends React.Component<DayOfWeekFormFieldProps> {
  renderLanguageMenuItem(item: typeof DayOfWeek.Type, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem key={`dow-${index}`} active={modifiers.active} onClick={handleClick} text={item.frenchName!} />
      );
    } else {
      return null;
    }
  }

  filterDayOfWeek = (query, dow) => {
    return dow?dow.englishName?dow.englishName.toLowerCase().indexOf(query.toLowerCase()) >= 0: false: false;
  };

  render() {
    const { DayOfWeekStore, ...otherProps } = this.props;
    return (
      <DayOfWeekSelectInputFormField
        label={TLCode.PHARMACY_Language}
        name="name"
        inline={true}
        items={toJS(DayOfWeekStore!.getDayOfWeekList())}
        itemValueGetter={(item: any) => item.code}
        valueItemGetter={(value) => this.props.DayOfWeekStore!.getByCode(value)}
        inputValueRenderer={(item) => (item != null ? item.frenchName! : '')}
        itemRenderer={this.renderLanguageMenuItem}
        itemPredicate={this.filterDayOfWeek}
        allowEmpty={true}
        identifier={'dowId'}
        elementLabel={'frenchName'}
        labelSelectAnElement={""}
        helperText={this.props.translate(TLCode.CHOOSE_A_DAY)}
        placeholderSelection={TLCode.SelectADay}
        {...otherProps}
      />
    );
  }
}


export default withTranslate(DayOfWeekFormField);
